<template>
  <layout>
    <div class="page home">
      <AboutMe v-if="content.length > 0" :data="content" />
      <loading v-else />
    </div>
  </layout>
</template>

<script>
import AboutMe from '@/components/AboutMe'

export default {
  components: {
    AboutMe,
  },
  computed: {
    content() {
      const getters = this.$store.getters
      if (getters.pages.loaded && getters.portfolio.loaded) {
        return getters.pages['home']
      } else {
        return []
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue